import FlightIcon from '@mui/icons-material/Flight';
import { useMediaQuery, useTheme, Box } from '@material-ui/core';
import { setSelectedtab } from '../../reducers/UiReducer';
import { Icondivcss } from './Icondivcss';
import { useDispatch, useSelector } from 'react-redux';
export const Icondiv = () => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('xs'));
	const { tab } = useSelector((state) => state.ui);
	const dispatch = useDispatch();
	return (
		<Icondivcss>
			<div
				className='icondiv'
				style={{
					borderRadius: 25,
					width: 358,
					left: matches ? '6%' : '34%',
					top: matches ? '275px' : tab === 'regular'?'188px':'',
				}}>
				<Box
					display='flex'
					alignItems='center'
					onClick={() => dispatch(setSelectedtab('regular'))}>
					<span>
						<FlightIcon
							style={{
								fontSize: 40,
								padding: 4,
								color: tab === 'regular' ? 'rgb(7, 124, 193)' : '',
							}}></FlightIcon>
					</span>
					<span
						style={{
							color: tab === 'regular' ? 'rgb(7, 124, 193)' : '',
							fontWeight: 'bold',
						}}>
						Flights
					</span>
				</Box>
				<Box
					display='flex'
					alignItems='center'
					onClick={() => dispatch(setSelectedtab('fd'))}>
					<span>
						<FlightIcon
							style={{
								fontSize: 40,
								padding: 4,
								color: tab === 'fd' ? 'rgb(7, 124, 193)' : '',
							}}></FlightIcon>
					</span>
					<span
						style={{
							color: tab === 'fd' ? 'rgb(7, 124, 193)' : '',
							fontWeight: 'bold',
						}}>
						Promo Fare
					</span>
				</Box>
				{/* <div>
          <span>
            <HomeWorkIcon style={{ fontSize: 40, padding: 4 }}></HomeWorkIcon>
          </span>
          <p>Homestays</p>
        </div> */}
				{/* <div>
          <span>
            <HolidayVillageIcon
              style={{ fontSize: 40, padding: 4 }}
            ></HolidayVillageIcon>
          </span>
          <p>Hoiday packages</p>
        </div> */}
				{/* <div>
          <span>
            <TrainIcon style={{ fontSize: 40, padding: 4 }}></TrainIcon>
          </span>
          <p>Trains</p>
        </div> */}
				{/* <div>
          <span>
            <DirectionsBusFilledIcon
              style={{ fontSize: 40, padding: 4 }}
            ></DirectionsBusFilledIcon>
          </span>
          <p>Buses</p>
        </div> */}
				{/* <div>
          <span>
            <LocalTaxiIcon style={{ fontSize: 40, padding: 4 }}></LocalTaxiIcon>
          </span>
          <p>Cabs</p>
        </div> */}
				{/* <div>
          <span>
            <CreditCardIcon
              style={{ fontSize: 40, padding: 4 }}
            ></CreditCardIcon>
          </span>
          <p>Visa</p>
        </div> */}
				{/* <div>
          <span>
            <FlightTakeoffIcon
              style={{ fontSize: 40, padding: 4 }}
            ></FlightTakeoffIcon>
          </span>
          <p>Charter flights</p>
        </div> */}
				{/* <div>
          <span>
            <DownhillSkiingIcon
              style={{ fontSize: 40, padding: 4 }}
            ></DownhillSkiingIcon>
          </span>
          <p>Activities</p>
        </div> */}
			</div>
		</Icondivcss>
	);
};
